import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import { formatDateTime } from '@dataGrid/gridUtilities';

const styles = (theme) => ({
  table: {
    minWidth: 150,
    border: `1px solid ${theme.dividerColorSecondary}`,
    borderRadius: '4px',
    fontSize: theme.textFontSize,
    borderCollapse: 'separate',
    borderSpacing: 0,
    overflow: 'hidden'
  },
  tableHead: {
    backgroundColor: theme.gridHeaderBGColor,
  },
  tableRow: {
    height: 'fit-content',
    '&:last-child $tableCell': {
      borderBottom: 'none'
    }
  },
  tableHeaderCell: {
    fontWeight: 600,
    color: theme.gridHeaderFontColor,
    padding: 6,
    borderBottom: 'none'
  },
  tableCell: {
    padding: 6,
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
    borderBottom: `1px solid ${theme.dividerColorSecondary}`
  },
  noDataCell: {
    textAlign: 'center',
    fontSize: theme.textFontSize,
    color: theme.disableButtonText,
    borderBottom: 'none'
  }
});

const ShipmentsList = ({ classes, shipments }) => {
  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableHeaderCell}>IB ETA</TableCell>
          <TableCell className={classes.tableHeaderCell}>Shipment Status</TableCell>
          <TableCell className={classes.tableHeaderCell}>Bay Location</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {shipments.length > 0 ? (
          shipments.map((shipment, index) => (
            <TableRow key={index} className={classes.tableRow}>
              <TableCell className={classes.tableCell}>
                {shipment.ibeta ? formatDateTime({ value: shipment.ibeta }) : '-'}
              </TableCell>
              <TableCell className={classes.tableCell}>{shipment.shipmentStatus ?? '-'}</TableCell>
              <TableCell className={classes.tableCell}>{shipment.bayLocation ?? '-'}</TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell className={classes.noDataCell} colSpan={3}>
              No data available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(ShipmentsList);
